import { render, staticRenderFns } from "./lottery-SSC.vue?vue&type=template&id=c6c760e8&scoped=true"
import script from "./lottery-SSC.vue?vue&type=script&lang=js"
export * from "./lottery-SSC.vue?vue&type=script&lang=js"
import style0 from "./lottery-SSC.vue?vue&type=style&index=0&id=c6c760e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c760e8",
  null
  
)

export default component.exports